import RootLayout from './layout'; 
import Home from './home/home';
import Profile from './profile/profile';

let browserRouter = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/test2",
        element: <Profile />,
      },
    ]
  },
  
]

export default browserRouter;